import { render, staticRenderFns } from "./chart-detail-overlay.vue?vue&type=template&id=4e36dc71&scoped=true"
import script from "./chart-detail-overlay.vue?vue&type=script&lang=js"
export * from "./chart-detail-overlay.vue?vue&type=script&lang=js"
import style0 from "./chart-detail-overlay.vue?vue&type=style&index=0&id=4e36dc71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36dc71",
  null
  
)

export default component.exports